import React from 'react';
import { Link } from 'react-router-dom';
import ServicePage from '../../components/site/ServicePage';
import { WEBSITE_FAQS as FAQS } from '../../site/faqs';
import { CONTACT } from '../../site/nav';

export default function Website() {
  return (
    <ServicePage
      path="/website"
      eyebrow="AI sales platform"
      title="Your whole store, selling online, with an assistant that closes."
      lead="Every piece you carry, online, with an AI designer that sells it. Shoppers talk or type, and it filters, opens products, compares, and builds the cart. Live today on eastbay.direct."
      proof={{ label: 'Open eastbay.direct', href: CONTACT.liveSite }}
      features={[
        { title: 'The designer works the page', text: 'Ask for a grey sectional under $1,500 that seats five. The options open.' },
        { title: 'Every piece, every fact', text: 'Price, dimensions, colours, material, brand, and whether it is in stock.' },
        { title: 'Compare, save, build a room', text: 'Pieces side by side, a saved list, and a short starter that finds matching options.' },
        { title: 'What goes with it', text: 'The designer suggests the chair, the table, and the rug.' },
        { title: 'Your answers to hard questions', text: 'Price match, financing, returns, and stock follow your stated policy.' },
        { title: 'A person when they want one', text: 'Your number and a callback form appear when the shopper asks or is ready to buy.' },
      ]}
      customer={{
        title: 'What your shopper gets',
        items: [
          { title: 'Help, not a search box', text: 'They say what they want and the page shows it.' },
          { title: 'Answers at 9 pm', text: 'Sizes, prices, delivery area, and what fits, any hour.' },
          { title: 'The same site in Spanish', text: 'Pages in Spanish, and a designer that answers in the language the shopper uses.' },
        ],
      }}
      steps={[
        { title: 'We rebuild around your catalog', text: 'Your brands, prices, delivery area, and photos.' },
        { title: 'AI can read every page', text: 'Your whole catalog, written so Google and AI assistants can recommend it.' },
        { title: 'You go live on your domain', text: 'Old addresses redirect. Your rankings and your number stay the same.' },
      ]}
      faqs={FAQS}
      closing={{ title: 'Try one now.', text: 'Open eastbay.direct, tap the designer, and ask for a sofa.' }}
    >
      <section className="pb-4 px-4">
        <p className="text-center text-sm text-gray-400">
          Already running an ecommerce site? The same agent goes on top of it.{' '}
          <Link to="/website-agent" className="text-blue-300 hover:text-white underline underline-offset-4">AI Designer</Link>
        </p>
      </section>
    </ServicePage>
  );
}
